import React from 'react';
import { LTText } from '@lambdatestincprivate/lt-components';
import './SharedHeader.css';
import HeaderTitle from './custom-header/HeaderTitle';

function SharedHeader() {
  return (
    <div className="hyp-shared-header">
      <div className="hyp-shared-header-logo">
        <a href="https://www.lambdatest.com/">
          <img
            src="https://assets.testmu.ai/resources/images/logos/logo.svg"
            alt="Logo"
            height="26"
          />
        </a>
      </div>
      <div className="hyp-shared-header-separator"></div>
      <HeaderTitle />
    </div>
  );
}

export default SharedHeader;
